import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754423a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TheTime" }
const _hoisted_2 = ["value", "disabled", "placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "floating-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: _normalizeClass(["TheTime", { invalid: _ctx.isInvalid, disabled: _ctx.disabled, withplaceholder: Boolean(_ctx.placeholder) }]),
      value: _ctx.value,
      type: "text",
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args)))
    }, null, 42, _hoisted_2), [
      [_directive_maska, { mask: _ctx.TIME_MASK, tokens: _ctx.TIME_TOKENS }]
    ]),
    (Boolean(_ctx.placeholder))
      ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
      : _createCommentVNode("", true)
  ]))
}